// UI strings for Yksi puhelin (2026-10-09; no password since 2026-10-13, together/onephone/): Illan tie on
// one phone. The screen says whose turn it is and hides the previous view at each hand-over. Finnish
// (default) and English side by side, the same shape.
import { defineArea } from '../area';

/** A person's name in the genitive and allative (Roosa → Roosan, Roosalle; Axel → Axelin, Axelille; docs/FINNISH-STYLE.md "Nimien taivutus"). */
const vowelEnd = (name: string) => /[aeiouyäöå]$/i.test(name);
const fiGen = (name: string) => (vowelEnd(name) ? `${name}n` : `${name}in`);
const fiAll = (name: string) => (vowelEnd(name) ? `${name}lle` : `${name}ille`);

export const onePhoneFi = {
  // the mode, on the week's card and the evening's first screen
  modeTwo: 'Kaksi puhelinta · vaihda',
  modeOne: 'Yksi puhelin · vaihda',
  toOneLabel: 'Kaksi puhelinta. Vaihda yhteen puhelimeen',
  toTwoLabel: 'Yksi puhelin. Vaihda kahteen puhelimeen',
  // the hand-over screen
  turn: (name: string) => `${fiGen(name)} vuoro`,
  handTo: (name: string) => `Anna puhelin ${fiAll(name)}`,
  hidden: 'Edellinen näkymä on piilossa.',
  iAm: (name: string) => `Olen ${name}`,
  // the step vote
  voteOf: (name: string) => `${name}:`,
  // a scene line and the Halloween line
  lineOf: (name: string) => `${fiGen(name)} repliikki`,
  records: (name: string) => `${name} äänittää`,
  whoRecords: 'Kuka äänittää?',
};

export type OnePhoneMessages = typeof onePhoneFi;

export const onePhoneEn: OnePhoneMessages = {
  modeTwo: 'Two phones · switch',
  modeOne: 'One phone · switch',
  toOneLabel: 'Two phones. Switch to one phone',
  toTwoLabel: 'One phone. Switch to two phones',
  turn: (name) => `${name}’s turn`,
  handTo: (name) => `Hand the phone to ${name}`,
  hidden: 'The previous view is hidden.',
  iAm: (name) => `I am ${name}`,
  voteOf: (name) => `${name}:`,
  lineOf: (name) => `${name}’s line`,
  records: (name) => `${name} records`,
  whoRecords: 'Who records?',
};

// Messages.onePhone (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('onePhone', onePhoneFi, onePhoneEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof onePhoneFi> {}
}
